import { render } from "./ProductVideo.vue?vue&type=template&id=770d7c16&scoped=true"
import script from "./ProductVideo.vue?vue&type=script&lang=js"
export * from "./ProductVideo.vue?vue&type=script&lang=js"

import "./ProductVideo.vue?vue&type=style&index=0&id=770d7c16&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770d7c16"]])

export default __exports__